import PageOurProduct from "containers/OurProduct/OurProduct";
import Page404 from "containers/Page404/Page404";
import PageAbout from "containers/PageAbout/PageAbout";
import PageContact from "containers/PageContact/PageContact";
import PageHome from "containers/PageHome/PageHome";
import SiteHeader from "containers/SiteHeader";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "shared/Footer/Footer";
// import ScrollToTop from "./ScrollToTop";
import { Page } from "./types";
import PageOurProductDetails from "containers/OurProduct/OurProductDetails";
import ScrollToTop from "./ScrollToTop";

export const pages: Page[] = [
  { path: "/", component: PageHome },

  { path: "/contact", component: PageContact },
  { path: "/about", component: PageAbout },
  { path: "/products", component: PageOurProduct },
  { path: "product/:slug", component: PageOurProductDetails },
  { path: "*", component: Page404 },
];

const MyRoutes = () => {
  return (
    <BrowserRouter>
      <Toaster />
      <ScrollToTop />
      <SiteHeader />
      <Routes>
        {pages.map(({ component: Component, path }, index) => {
          return <Route key={index} element={<Component />} path={path} />;
        })}
        <Route element={<Page404 />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default MyRoutes;
